module.exports = __webpack_public_path__ + "static/media/EnvPromo-Shot104.1834fd45.jpg";